import ApiService from '@/services/api.service';
import { UserService } from '@/services/user.service';

export const getJobList = async ({ state, commit }) => {
  commit('initRequest');
  try {
    return await UserService.getJobList();
  } catch (err) {
    if (!state.authError) {
      commit('setError', {
        isError: true,
        errorMessage: !state.error
          ? 'Ha ocurrido un error, inténtelo nuevamente.'
          : state.authErrorMessage
      });
    }
  } finally {
    commit('finishRequest');
  }
};

export const fetchUbicationData = async ({ state, commit }) => {
  commit('initRequest');
  try {
    commit('fetchRequest');
    let responseDepartamentos = await ApiService.get(
      `${process.env.VUE_APP_BASE_URL}/ref-data/departamentos`
    );
    let responsePaises = await ApiService.get(
      `${process.env.VUE_APP_BASE_URL}/ref-data/paises`
    );
    commit('setUbication', {
      paises: responsePaises.data.data,
      departamentos: responseDepartamentos.data.data
    });
  } catch (err) {
    console.log(err.response);
    commit('setError', {
      isError: true,
      errorMessage: 'Ha ocurrido un error, inténtelo nuevamente.'
    });
  } finally {
    commit('finishRequest');
  }
};

export const getProfileInfo = async ({ state, commit }) => {
  try {
    commit('fetchRequest');
    const profileData = await UserService.getProfile();
    commit('setProfileData', profileData);
    commit('finishRequest');
  } catch (err) {
    if (!state.authError) {
      commit('setError', {
        isError: true,
        errorMessage: 'Ha ocurrido un error, inténtelo nuevamente.'
      });
    }
  } finally {
    commit('finishRequest');
  }
};

export const getJobById = async ({ commit }, id) => {
  commit('initRequest');
  const url = `${process.env.VUE_APP_BASE_URL}/usuarioUNI/trabajo/obtener/${id}`;
  try {
    const jobResponse = await ApiService.get(url);
    return jobResponse.data.data;
  } catch (err) {
    commit('setError', {
      isError: true,
      errorMessage: 'Ha ocurrido un error, inténtelo nuevamente.'
    });
  } finally {
    commit('finishRequest');
  }
};

export const setFavorite = async ({ commit }, { idTrabajo, isFavorite }) => {
  commit('initRequest');
  const url = `${process.env.VUE_APP_BASE_URL}/usuarioUNI/trabajo/${
    isFavorite ? 'agregarFavorito' : 'quitarFavorito'
  }`;
  try {
    await ApiService.post(url, { idTrabajo });
    return;
  } catch (err) {
    console.log(err.response);
    commit('setError', {
      isError: true,
      errorMessage: 'Ha ocurrido un error, inténtelo nuevamente.'
    });
  } finally {
    commit('finishRequest');
  }
};

export const applyJob = async ({ commit }, idTrabajo) => {
  commit('initRequest');
  const url = `${process.env.VUE_APP_BASE_URL}/usuarioUNI/postular`;
  try {
    await ApiService.post(url, { idTrabajo });
    return;
  } catch (err) {
    commit('setError', {
      isError: true,
      errorMessage: 'Ha ocurrido un error, inténtelo nuevamente.'
    });
  } finally {
    commit('finishRequest');
  }
};

export const uploadPhotoUser = async ({ commit }, photo) => {
  commit('initRequest');
  commit('initRequestResult');
  try {
    commit('fetchRequest');
    let response = await UserService.uploadPhoto(photo);
    commit('setRequestResult', response);
    return response;
  } catch (err) {
    commit('setError', {
      isError: true,
      errorMessage: 'Ha ocurrido un error, inténtelo nuevamente.'
    });
  } finally {
    commit('finishRequest');
  }
};

export const updateProfileInfo = async ({ commit }, body) => {
  commit('initRequest');
  commit('initRequestResult');
  try {
    commit('fetchRequest');
    let response = await UserService.updateProfile(body);
    commit('setRequestResult', response);
    return response;
  } catch (err) {
    commit('setError', {
      isError: true,
      errorMessage: 'Ha ocurrido un error, inténtelo nuevamente.'
    });
  } finally {
    commit('finishRequest');
  }
};

export const fetchStateTest = async ({ commit }) => {
  commit('initRequest');
  try {
    commit('fetchRequest');
    let { data } = await UserService.getStateTest();
    commit('setStateTest', data);
  } catch (err) {
    commit('setError', {
      isError: true,
      errorMessage: 'Ha ocurrido un error, inténtelo nuevamente.'
    });
  } finally {
    commit('finishRequest');
  }
};

export const startTest = async ({ commit }) => {
  commit('initRequest');
  try {
    commit('fetchRequest');
    let response = await UserService.startTest();
    return response;
  } catch (err) {
    console.log(err.response);
    commit('setError', {
      isError: true,
      errorMessage: 'Ha ocurrido un error, inténtelo nuevamente.'
    });
  } finally {
    commit('finishRequest');
  }
};

export const fetchNextQuestionTest = async ({ commit }) => {
  commit('initRequest');
  try {
    commit('fetchRequest');
    let response = await UserService.getNextQuestion();
    commit('setNextQuestionTest', response);
  } catch (err) {
    console.log(err.response);
    commit('setError', {
      isError: true,
      errorMessage: 'Ha ocurrido un error, inténtelo nuevamente.'
    });
  } finally {
    commit('finishRequest');
  }
};

export const submitQuestionTest = async ({ commit }, payload) => {
  commit('initRequest');
  try {
    commit('fetchRequest');
    let response = await UserService.submitQuestion(payload);
    return response;
  } catch (err) {
    console.log(err.response);
    commit('setError', {
      isError: true,
      errorMessage: 'Ha ocurrido un error, inténtelo nuevamente.'
    });
  } finally {
    commit('finishRequest');
  }
};

export const endTest = async ({ commit }) => {
  commit('initRequest');
  try {
    commit('fetchRequest');
    let response = await UserService.endTest();
    return response;
  } catch (err) {
    console.log(err.response);
    commit('setError', {
      isError: true,
      errorMessage: 'Ha ocurrido un error, inténtelo nuevamente.'
    });
  } finally {
    commit('finishRequest');
  }
};

export const getCarreras = async ({ commit }) => {
  commit('initRequest');
  try {
    commit('fetchRequest');
    let response = await ApiService.get(
      ApiService.getEndpoint('/ref-data/carreras')
    );
    commit('setListaCarreras', response.data.data);
  } catch (err) {
    console.log(err.response);
    commit('setError', {
      isError: true,
      errorMessage: 'Ha ocurrido un error, inténtelo nuevamente.'
    });
  } finally {
    commit('finishRequest');
  }
};

export const fetchIndustrias = async ({ commit }) => {
  commit('initRequest');
  try {
    commit('fetchRequest');
    let response = await ApiService.get(
      ApiService.getEndpoint('/ref-data/industrias')
    );
    commit('setListaIndustrias', response.data.data);
  } catch (err) {
    commit('setError', {
      isError: true,
      errorMessage: 'Ha ocurrido un error, inténtelo nuevamente.'
    });
  } finally {
    commit('finishRequest');
  }
};

export const fetchResultadosGlobalesTest = async ({ commit }) => {
  commit('initRequest');
  try {
    commit('fetchRequest');
    let response = await ApiService.get(
      ApiService.getEndpoint('/usuarioUNI/test-adaptativo/resultados-globales')
    );
    commit('setResultadosGlobalesTest', response.data.data);
  } catch (err) {
    commit('setError', {
      isError: true,
      errorMessage: 'Ha ocurrido un error, inténtelo nuevamente.'
    });
  } finally {
    commit('finishRequest');
  }
};

export const fetchPublicaciones = async ({ commit }) => {
  commit('initRequest');
  try {
    commit('fetchRequest');
    let response = await ApiService.get(
      ApiService.getEndpoint('/usuarioUNI/publicaciones')
    );
    commit('setListaPublicaciones', response.data.data);
  } catch (err) {
    commit('setError', {
      isError: true,
      errorMessage: 'Ha ocurrido un error, inténtelo nuevamente.'
    });
  } finally {
    commit('finishRequest');
  }
};
